var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.53 7.90818C17.46 7.89818 17.39 7.89818 17.32 7.90818C15.77 7.85818 14.54 6.58818 14.54 5.02818C14.54 3.43818 15.83 2.13818 17.43 2.13818C19.02 2.13818 20.32 3.42818 20.32 5.02818C20.31 6.58818 19.08 7.85818 17.53 7.90818Z",
    fill: "#464650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7901 14.8382C19.6701 15.5882 18.1001 15.8682 16.6501 15.6782C17.0301 14.8582 17.2301 13.9482 17.2401 12.9882C17.2401 11.9882 17.0201 11.0382 16.6001 10.2082C18.0801 10.0082 19.6501 10.2882 20.7801 11.0382C22.3601 12.0782 22.3601 13.7882 20.7901 14.8382Z",
    fill: "#464650"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44016 7.90818C6.51016 7.89818 6.58016 7.89818 6.65016 7.90818C8.20016 7.85818 9.43016 6.58818 9.43016 5.02818C9.43016 3.42818 8.14016 2.13818 6.54016 2.13818C4.95016 2.13818 3.66016 3.42818 3.66016 5.02818C3.66016 6.58818 4.89016 7.85818 6.44016 7.90818Z",
    fill: "#464650"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55012 12.9882C6.55012 13.9582 6.76012 14.8782 7.14012 15.7082C5.73012 15.8582 4.26012 15.5582 3.18012 14.8482C1.60012 13.7982 1.60012 12.0882 3.18012 11.0382C4.25012 10.3182 5.76012 10.0282 7.18012 10.1882C6.77012 11.0282 6.55012 11.9782 6.55012 12.9882Z",
    fill: "#464650"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1198 16.0082C12.0398 15.9982 11.9498 15.9982 11.8598 16.0082C10.0198 15.9482 8.5498 14.4382 8.5498 12.5782C8.5598 10.6782 10.0898 9.13818 11.9998 9.13818C13.8998 9.13818 15.4398 10.6782 15.4398 12.5782C15.4298 14.4382 13.9698 15.9482 12.1198 16.0082Z",
    fill: "#464650"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8698 18.0782C7.3598 19.0882 7.3598 20.7482 8.8698 21.7482C10.5898 22.8982 13.4098 22.8982 15.1298 21.7482C16.6398 20.7382 16.6398 19.0782 15.1298 18.0782C13.4198 16.9282 10.5998 16.9282 8.8698 18.0782Z",
    fill: "#464650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.100a1769d55e740bab82b99d046d65af.svg";
export { ForwardRef as ReactComponent };